<template>
  <div class="page-container">
    <!-- 总览区域 -->
    <Card dis-hover class="overview-section">
      <div slot="title" class="section-title">
        <Icon type="ios-stats" size="20" />
        <span>资源点总览</span>
      </div>
      <Row :gutter="16" class="summary-row">
        <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
          <div class="summary-card summary-card-primary">
            <div class="summary-icon-wrapper">
              <Icon type="ios-flash" size="28" color="#2d8cf0" />
            </div>
            <div class="summary-content-wrapper">
              <div class="summary-label">可用资源点</div>
              <div class="summary-value primary">{{ formatNumber(summary.available_points) }}</div>
              <div class="summary-desc">当前可使用</div>
            </div>
          </div>
        </Col>
        <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
          <div class="summary-card summary-card-success">
            <div class="summary-icon-wrapper">
              <Icon type="ios-trending-up" size="28" color="#19be6b" />
            </div>
            <div class="summary-content-wrapper">
              <div class="summary-label">累计充值</div>
              <div class="summary-value">{{ formatNumber(summary.total_points) }}</div>
              <div class="summary-desc">历史累计充值</div>
            </div>
          </div>
        </Col>
        <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
          <div class="summary-card summary-card-warning">
            <div class="summary-icon-wrapper">
              <Icon type="ios-trending-down" size="28" color="#ff9900" />
            </div>
            <div class="summary-content-wrapper">
              <div class="summary-label">累计消耗</div>
              <div class="summary-value">{{ formatNumber(summary.used_points) }}</div>
              <div class="summary-desc">已使用资源点</div>
            </div>
          </div>
        </Col>
        <Col :xl="6" :lg="6" :md="12" :sm="12" :xs="24">
          <div class="summary-card summary-card-info">
            <div class="summary-icon-wrapper">
              <Icon type="ios-time" size="28" color="#808695" />
            </div>
            <div class="summary-content-wrapper">
              <div class="summary-label">最近刷新</div>
              <div class="summary-value small">{{ lastRefresh }}</div>
              <div class="summary-desc">数据更新时间</div>
            </div>
          </div>
        </Col>
      </Row>
    </Card>

    <Card class="search-card" dis-hover>
      <Form inline :label-width="120" :model="search" @submit.native.prevent>
        <FormItem label="订单号">
          <Input v-model.trim="search.order_sn" placeholder="请输入订单号" clearable style="width: 200px" />
        </FormItem>
        <FormItem label="状态">
          <Select v-model="search.status" clearable placeholder="全部" style="width: 140px">
            <Option v-for="item in statusOptions" :key="item.value" :value="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" icon="ios-search" @click="handleSearch">查询</Button>
          <Button style="margin-left: 8px" @click="resetSearch">重置</Button>
        </FormItem>
      </Form>
    </Card>

    <Card dis-hover>
      <Spin fix v-if="loading" />
      <Table :columns="columns" :data="list.data" border stripe>
        <template #orderInfo="{ row }">
          <div>
            <p>订单号：{{ row.order_sn }}</p>
            <p>套餐：{{ row.package_name || '-' }}</p>
          </div>
        </template>
        <template #points="{ row }">
          <div>
            <p>总资源点：<span class="bold-text">{{ row.total_points }}</span></p>
            <p>剩余资源点：<span class="bold-text primary">{{ row.available_points }}</span></p>
          </div>
        </template>
        <template #status="{ row }">
          <Tag :color="statusColor(row.status)">{{ statusText(row.status) }}</Tag>
        </template>
        <template #time="{ row }">
          <div>
            <p>创建：{{ row.created_at || '-' }}</p>
            <p>到期：<span :class="isExpired(row.expire_time) ? 'text-danger' : ''">{{ row.expire_time || '-' }}</span></p>
          </div>
        </template>
      </Table>
      <Page
        v-if="list.total > 0"
        class="pagination"
        :total="list.total"
        :current="search.page"
        :page-size="search.pageSize"
        :page-size-opts="[10,15,20,30]"
        show-total
        show-sizer
        @on-change="handlePageChange"
        @on-page-size-change="handlePageSizeChange"
      />
    </Card>
  </div>
</template>

<script>
export default {
  name: 'AiPointsResourceManage',
  data () {
    return {
      loading: false,
      search: {
        order_sn: '',
        status: '',
        page: 1,
        pageSize: 10
      },
      list: {
        data: [],
        total: 0
      },
      summary: {
        total_points: 0,
        available_points: 0,
        used_points: 0
      },
      lastRefresh: '-',
      statusOptions: [
        { label: '全部', value: '' },
        { label: '未生效', value: 0 },
        { label: '使用中', value: 1 },
        { label: '已用完', value: 2 },
        { label: '已过期', value: 3 },
        { label: '已作废', value: 4 }
      ],
      columns: [
        { title: '订单信息', slot: 'orderInfo', minWidth: 200 },
        { title: '资源点', slot: 'points', minWidth: 150 },
        { title: '订单状态', slot: 'status', minWidth: 110, align: 'center' },
        { title: '时间信息', slot: 'time', minWidth: 200 }
      ]
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      this.loading = true
      const payload = { search: { ...this.search } }
      this.requestApi('/adm/get_balance_list', payload).then(res => {
        this.loading = false
        if (res.status === 1) {
          const data = res.data || {}
          this.list = data.list || { data: [], total: 0 }
          const summary = data.summary || { total_points: 0, available_points: 0, used_points: 0 }
          this.summary = {
            total_points: Number(summary.total_points || 0),
            available_points: Number(summary.available_points || 0),
            used_points: summary.used_points !== undefined ? Number(summary.used_points) : Math.max(0, Number(summary.total_points || 0) - Number(summary.available_points || 0))
          }
          this.lastRefresh = this.getDateTime(new Date())
        } else {
          this.list = { data: [], total: 0 }
          this.summary = { total_points: 0, available_points: 0, used_points: 0 }
          this.alertErr(res.msg || '获取资源点信息失败')
        }
      })
    },
    handleSearch () {
      this.search.page = 1
      this.fetchData()
    },
    resetSearch () {
      this.search = {
        order_sn: '',
        status: '',
        page: 1,
        pageSize: this.search.pageSize
      }
      this.fetchData()
    },
    handlePageChange (page) {
      this.search.page = page
      this.fetchData()
    },
    handlePageSizeChange (size) {
      this.search.pageSize = size
      this.handleSearch()
    },
    statusText (status) {
      const map = {
        0: '未生效',
        1: '使用中',
        2: '已用完',
        3: '已过期',
        4: '已作废'
      }
      return map[status] || '未知'
    },
    statusColor (status) {
      const map = {
        0: 'default',
        1: 'success',
        2: 'warning',
        3: 'error',
        4: 'default'
      }
      return map[status] || 'default'
    },
    isExpired (expireTime) {
      if (!expireTime) return false
      return new Date(expireTime).getTime() < Date.now()
    },
    formatNumber (num) {
      if (num === null || num === undefined) return '0'
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    getDateTime (date) {
      if (!date) date = new Date()
      const d = new Date(date)
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      const hours = String(d.getHours()).padStart(2, '0')
      const minutes = String(d.getMinutes()).padStart(2, '0')
      const seconds = String(d.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.page-container {
  padding: 16px;
  background: #f5f7f9;
  min-height: calc(100vh - 64px);
}

/* 总览区域 */
.overview-section {
  margin-bottom: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  font-weight: 600;
}

.summary-row {
  margin-bottom: 0;
}

.summary-card {
  display: flex;
  align-items: center;
  padding: 20px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #e8eaec;
  transition: all 0.3s ease;
  margin-bottom: 16px;
  height: 100%;
}

.summary-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.summary-card-primary {
  border-left: 4px solid #2d8cf0;
  background: linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%);
}

.summary-card-success {
  border-left: 4px solid #19be6b;
  background: linear-gradient(135deg, #f0f9f4 0%, #ffffff 100%);
}

.summary-card-warning {
  border-left: 4px solid #ff9900;
  background: linear-gradient(135deg, #fff7e6 0%, #ffffff 100%);
}

.summary-card-info {
  border-left: 4px solid #808695;
  background: linear-gradient(135deg, #f5f7f9 0%, #ffffff 100%);
}

.summary-icon-wrapper {
  width: 56px;
  height: 56px;
  min-width: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 12px;
  margin-right: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.summary-content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.summary-label {
  font-size: 13px;
  color: #808695;
  margin-bottom: 8px;
  font-weight: 500;
}

.summary-value {
  font-size: 28px;
  font-weight: 700;
  color: #17233d;
  line-height: 1.2;
  margin-bottom: 4px;
}

.summary-value.small {
  font-size: 16px;
  color: #808695;
  font-weight: 600;
}

.summary-value.primary {
  color: #2d8cf0;
}

.summary-desc {
  font-size: 12px;
  color: #c5c8ce;
  margin-top: 2px;
}

.search-card {
  margin-bottom: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.search-card .ivu-card-body {
  padding: 16px 20px;
}

.search-card .ivu-form-item {
  margin-bottom: 0;
  margin-right: 16px;
}

.search-card .ivu-form-item:last-child {
  margin-right: 0;
}

.table-card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.table-card .ivu-card-body {
  padding: 20px 24px;
}

.pagination {
  margin-top: 20px;
  text-align: right;
  padding-top: 16px;
  border-top: 1px solid #e8eaec;
}

.bold-text {
  font-weight: 600;
}

.primary {
  color: #2d8cf0;
}

.text-danger {
  color: #ed4014;
}
</style>

